import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import Home from '../views/Home.vue'
import SheqsyEmployee from '../views/Sheqsy/Employee.vue'
import SheqsyCompany from '../views/Sheqsy/Company.vue'
import SheqsyCompanyForm from '../views/Sheqsy/CompanyForm.vue'
import SheqsyEmployeeForm from '../views/Sheqsy/EmployeeForm.vue'
import SheqsyEmployeeBulkUpdate from '../views/Sheqsy/EmployeeBulk.vue'
import SheqsyEvent from '../views/Sheqsy/Event.vue'
import SheqsyEventForm from '../views/Sheqsy/EventForm.vue'
import SheqsyEventArchive from '../views/Archives/Sheqsy.vue'
import SheqsyEventArchiveForm from '../views/Archives/SheqsyForm.vue'
import ReceiverExport from '../views/Receiver/Export.vue'
import ReceiverExportForm from '../views/Receiver/ExportForm.vue'
import ReceiverEvent from '../views/Receiver/Event.vue'
import ReceiverEventArchive from '../views/Archives/Receiver.vue'
import ReceiverCorrelation from '../views/Receiver/Correlation.vue'
import ReceiverCorrelationForm from '../views/Receiver/CorrelationForm.vue'
import ReceiverTemplate from '../views/Receiver/Template.vue'
import ReceiverTemplateForm from '../views/Receiver/TemplateForm.vue'
import ReceiverUser from '../views/Receiver/User.vue'
import ReceiverUserForm from '../views/Receiver/UserForm.vue'
import ReceiverCompany from '../views/Receiver/Company.vue'
import ReceiverCompanyForm from '../views/Receiver/CompanyForm.vue'
import SimsSignal from '../views/Sims/Signal.vue'
import SimsSignalForm from '../views/Sims/SignalForm.vue'
import Login from '../views/Login.vue'
import Logout from '../views/Logout.vue'
import Admin from '../views/Admin.vue'

import store from '../store'

const routes: Array<RouteRecordRaw> = [
    { path: '/login', component: Login, meta: { anon: true } },
    { path: '/', component: Home, meta: { authority: 'self.Login', navlabel: 'Dashboard' } },
    { path: '/sheqsy/event', component: SheqsyEvent, meta: { authority: 'sheqsy.event.View', navlabel: 'Sheqsy Events' } },
    { path: '/sheqsy/event/:slug', component: SheqsyEventForm },
    { path: '/receiver/correlation', component: ReceiverCorrelation, meta: { authority: 'receiver.correlation.View', navlabel: 'Processor History' } },
    { path: '/receiver/correlation/:slug', component: ReceiverCorrelationForm },
    { path: '/sims/signal', component: SimsSignal, meta: { authority: 'sims.signal.View', navlabel: 'Sims Signals' } },
    { path: '/sims/signal/:slug', component: SimsSignalForm },
    { name: 'Admin', path: '/admin', component: Admin, children: [
        { path: '/sheqsy/company', component: SheqsyCompany, meta: { authority: 'sheqsy.company.View', navlabel: 'Sheqsy Companies' } },
        { path: '/sheqsy/company/:slug', component: SheqsyCompanyForm },
        { path: '/sheqsy/employee', component: SheqsyEmployee, meta: { authority: 'sheqsy.employee.View', navlabel: 'Sheqsy Employees' } },
        { path: '/sheqsy/employee/bulk', component: SheqsyEmployeeBulkUpdate },
        { path: '/sheqsy/employee/:slug', component: SheqsyEmployeeForm },
        { path: '/receiver/export', component: ReceiverExport, meta: { authority: 'receiver.export.View', navlabel: 'Receiver Exports' }  },
        { name: 'Receiver Export', path: '/receiver/export/:slug', component: ReceiverExportForm },
        { path: '/receiver/template', component: ReceiverTemplate, meta: { authority: 'receiver.template.View', navlabel: 'Receiver Templates' } },
        { path: '/receiver/template/:slug', component: ReceiverTemplateForm },
        { path: '/receiver/company', component: ReceiverCompany, meta: { authority: 'receiver.company.View', navlabel: 'Companies' } },
        { path: '/receiver/company/:slug', component: ReceiverCompanyForm },
        { path: '/receiver/user', component: ReceiverUser, meta: { authority: 'receiver.user.View', navlabel: 'Users' } },
        { path: '/receiver/user/:slug', component: ReceiverUserForm },
        { path: '/receiver/event', component: ReceiverEvent, meta: { authority: 'receiver.event.View', navlabel: 'Receiver Events' } },
        { path: '/archives/receiver', component: ReceiverEventArchive, meta: { authority: 'receiver.event.Manage', navlabel: 'Receiver Archive' } },
        { path: '/archives/sheqsy', component: SheqsyEventArchive, meta: { authority: 'sheqsy.event.Manage', navlabel: 'Sheqsy Archive' } },
        { path: '/archives/sheqsy/:slug', component: SheqsyEventArchiveForm, },
        { path: '/logout', component: Logout, meta: { authority: 'self.Login', navlabel: 'Log out' } },
    ]},

    // otherwise redirect to home
    { path: '/:pathMatch(.*)*', redirect: '/' }
]

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL), // uris without hashes #, see https://router.vuejs.org/guide/essentials/history-mode.html#html5-history-mode
    routes,
    linkActiveClass: "active",
});

router.beforeResolve(async to => {
    if (to.meta.anon) {
        return;
    }

    store.dispatch('maintainAuthToken')
    if (!store.getters.isLoggedIn) {
        return '/login';
    }
});

export default router;